import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function FacebookIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'Facebook',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Facebook</title>
			<path
				d="M30.5348 0H9.46517C4.2377 0 0 4.2377 0 9.46517V30.5348C0 35.7623 4.2377 40 9.46517 40H30.5348C35.7623 40 40 35.7623 40 30.5348V9.46517C40 4.2377 35.7623 0 30.5348 0Z"
				fill={bg}
			/>
			<path d="M28.903 20.0151L27.9529 25.6858H11.7158V20.0151H28.903Z" fill={g} />
			<path
				d="M28.9158 7.75809V13.0078H25.9719C24.443 13.0078 23.2049 14.2468 23.2049 15.7747V39.9988H16.9248V14.5855C16.9248 10.6475 20.1175 7.45575 24.0555 7.45575C26.1077 7.38782 27.4625 7.59257 28.9168 7.75809H28.9158Z"
				fill={g}
			/>
		</svg>
	);
}
